export const addScenarioToCart = (data) =>{
  return {
    type:"ADD_ITEMS",
    count : data.count,
    items : data.items,
  }
}

export const addGroupToCart = (obj) =>{
  console.log("ADD_CAD",obj.description)
  return{
    type : "ADD_CAD",
    description : obj.description,
  }
}


export const updateShoppingCart = (obj) =>{
  return{
    type : "UPDATE_CART",
    count : obj.count,
    items : obj.items,
  }
}
